@if (tabs && tabs.length > 1) {
    <ds-segmented-control
        msThemedSegmentedControl
        [themeInverse]="segmentedControlThemeInverse"
        [fullWidth]="true"
        [activeOption]="currentSelectedTab ?? ''"
        (activeOptionChange)="selected($event)">
        @for (tab of tabs; track $index) {
            <ds-segmented-option [name]="tab.id.toString()" [title]="tab.title ?? ''">
                <ng-template #dsTemplate>
                    @if (tab.icon) {
                        <vn-icon size="16" [name]="tab.icon" />
                    }
                </ng-template>
            </ds-segmented-option>
        }
    </ds-segmented-control>
}
